import { ProductTypesFlat } from "../productCommons.js";

export const getContainerTypes = (
  containerType: string | undefined | null,
): string[] => {
  if (!containerType) {
    return [];
  }

  const type = ProductTypesFlat.find((i) => i.key === containerType);
  return [
    ...(type ? (type.path ?? []) : []),
    ...(type?.materialType ? [type.materialType] : []),
    containerType,
  ].filter(Boolean);
};
